import React, { useEffect, useState } from "react";
import { SecondaryButton, formatCurrency } from "../../../UI/DesignStandards";
import { supabase } from "../../../../supabaseClient";
import {
  downloadTournamentTotalsCsv,
  tournamentMoneyTotals,
} from "../../../../utility/directorMoney";

const Stat = ({ label, value }) => (
  <div>
    <dt className="text-sm text-brand-muted">{label}</dt>
    <dd className="font-score text-xl font-semibold text-brand-charcoal">
      {value}
    </dd>
  </div>
);

const SignupTotalsStrip = ({ signups, tournamentId, tournamentName: tournamentNameProp }) => {
  const totals = tournamentMoneyTotals(signups);
  const [loadedName, setLoadedName] = useState("");
  const tournamentName = tournamentNameProp || loadedName;

  useEffect(() => {
    if (tournamentNameProp || !tournamentId) return undefined;
    let cancelled = false;
    supabase
      .from("tournaments")
      .select("name")
      .eq("id", tournamentId)
      .maybeSingle()
      .then(({ data }) => {
        if (!cancelled) setLoadedName(data?.name || "");
      });
    return () => {
      cancelled = true;
    };
  }, [tournamentId, tournamentNameProp]);

  return (
    <div className="border border-brand-charcoal/10 rounded-lg px-4 py-3">
      <div className="flex flex-col gap-3 lg:flex-row lg:items-start lg:justify-between">
        <dl className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-x-6 gap-y-3 flex-1">
          <Stat label="Entries" value={totals.entries} />
          <Stat
            label="Online collected"
            value={formatCurrency(totals.onlineCollected)}
          />
          {totals.showCardDesk ? (
            <Stat
              label="Desk collected"
              value={formatCurrency(totals.deskCollected)}
            />
          ) : null}
          <Stat label="Due at desk" value={formatCurrency(totals.dueAtDesk)} />
          <Stat label="Refunds" value={formatCurrency(totals.refunds)} />
        </dl>
        <SecondaryButton
          onClick={() => downloadTournamentTotalsCsv(totals, tournamentName)}
          className="!px-3 !py-2 text-sm shrink-0"
        >
          Download CSV
        </SecondaryButton>
      </div>
      <p className="text-sm text-brand-muted mt-3">
        Totals include every signup, even rows hidden by filters.
      </p>
    </div>
  );
};

export default SignupTotalsStrip;
